export enum PaysafePaymentType {
  Card = 'CARD',
}
